/**
 * @module
 *
 * @description Constants leveraged for driver formatting.
 */

/**
 * The term lengths for Banking CDs.
 * @enum {string}
 */
export var BANKING_CD_TERM_LENGTHS = {
  ONE_YEAR: 'oneYear',
  THREE_YEAR: 'threeYear',
  FIVE_YEAR: 'fiveYear'
};
/**
 * Driver formats.
 * @enum {string}
 */

export var FORMATS = {
  CURRENCY: 'currency',
  CURRENCY_FRACTIONAL: 'currency-fractional',
  CURRENCY_WITH_CENTS: 'currency-with-cents',
  DECIMAL: 'decimal',
  NUMBER: 'number',
  PERCENT: 'percent',
  PERCENT_WITH_DECIMAL: 'percent-with-decimal',
  STRING: 'string',
  UNFORMATTED: 'unformatted'
};
/**
 * Mortgage canonical drivers from Marketplace.
 *
 * Should match {@link https://github.com/NerdWallet/marketplace/blob/5f540d904af69e7f9fd4df01a7d4a1c21facee07/src/schemas/mortgages/offer_details.json#L217-L220}
 *
 * @enum {string}
 */

export var MORTGAGES_CANONICAL_DRIVERS = {
  COVERAGE_AREA: 'COVERAGE_AREA',
  CREDIT_SCORE: 'CREDIT_SCORE',
  DOWN_PAYMENT: 'DOWN_PAYMENT',
  LTV: 'LTV'
};
/**
 * Driver value sizes.
 * @enum {string}
 */

export var VALUE_SIZES = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};
/**
 * Policies offered display values.
 * Pulled from https://github.com/NerdWallet/marketplace/blob/481652eeb107baf3d7a9bb9cdc2b500cd5a00d18/src/schemas/insurance/product_details.json#L153
 * @enum {string}
 */

export var POLICIES_OFFERED = {
  permanent: 'Permanent',
  permanent_and_no_exam: 'Permanent & no-exam',
  term: 'Term',
  term_and_no_exam: 'Term & no-exam',
  term_and_permanent: 'Term & permanent',
  term_permanent_and_no_exam: 'Term, permanent & no-exam'
};
/**
 * Can buy online display value.
 * Pulled from https://github.com/NerdWallet/marketplace/blob/481652eeb107baf3d7a9bb9cdc2b500cd5a00d18/src/schemas/insurance/product_details.json#L153
 * @enum {string}
 */

export var CAN_BUY_ONLINE = {
  true: 'Yes',
  false: 'No'
};